"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultUserAccountSubscriber = void 0;
const events_1 = require("events");
const addresses_1 = require("../addresses");
const webSocketAccountSubscriber_1 = require("./webSocketAccountSubscriber");
class DefaultUserAccountSubscriber {
    constructor(program, authority) {
        this.isSubscribed = false;
        this.program = program;
        this.authority = authority;
        this.eventEmitter = new events_1.EventEmitter();
    }
    subscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSubscribed) {
                return true;
            }
            const userPublicKey = yield addresses_1.getUserAccountPublicKey(this.program.programId, this.authority);
            this.userDataAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('user', this.program, userPublicKey);
            yield this.userDataAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('userAccountData', data);
                this.eventEmitter.emit('update');
            });
            const userAccountData = this.userDataAccountSubscriber.data;
            this.userPositionsAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('userPositions', this.program, userAccountData.positions);
            yield this.userPositionsAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('userPositionsData', data);
                this.eventEmitter.emit('update');
            });
            this.eventEmitter.emit('update');
            this.isSubscribed = true;
            return true;
        });
    }
    unsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isSubscribed) {
                return;
            }
            this.userDataAccountSubscriber.unsubscribe();
            this.userPositionsAccountSubscriber.unsubscribe();
            this.isSubscribed = false;
        });
    }
    getUserAccount() {
        return this.userDataAccountSubscriber.data;
    }
    getUserPositionsAccount() {
        return this.userPositionsAccountSubscriber.data;
    }
}
exports.DefaultUserAccountSubscriber = DefaultUserAccountSubscriber;
